"use client";

var _excluded = ["visible", "mode", "closeOnEsc", "closeOnClick", "onClose", "children"];

var _templateObject, _templateObject2;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React, { useEffect, useRef } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { CSSTransition } from "react-transition-group";
var GlobalTransitions = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .nib-overlay-enter {\n    opacity: 0.01;\n  }\n\n  .nib-overlay-enter-active {\n    opacity: 1;\n    transition: opacity .3s cubic-bezier(0.550, 0.085, 0.680, 0.530);\n  }\n\n  .nib-overlay-exit {\n    opacity: 1;\n  }\n\n  .nib-overlay-exit-active {\n    opacity: 0.01;\n    transition: opacity .3s cubic-bezier(0.550, 0.085, 0.680, 0.530);\n  }\n"])));
export var backgrounds = {
  light: "rgba(255,255,255,.9)",
  dark: "rgba(67,67,67,.9)"
}; // Do not try to prevent the `mode` prop leaking to the DOM by destructuring props.
// It causes closeOnClick to break (this.el is undefined)

export var OverlayComponent = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  overflow: auto;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: ", ";\n"])), function (props) {
  return props.mode === "light" ? backgrounds.light : backgrounds.dark;
});

var Overlay = function Overlay(_ref) {
  var _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? "dark" : _ref$mode,
      _ref$closeOnEsc = _ref.closeOnEsc,
      closeOnEsc = _ref$closeOnEsc === void 0 ? true : _ref$closeOnEsc,
      _ref$closeOnClick = _ref.closeOnClick,
      closeOnClick = _ref$closeOnClick === void 0 ? true : _ref$closeOnClick,
      onClose = _ref.onClose,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var ref = useRef();

  function handleClick(event) {
    if (closeOnClick && event.target === ref.current) {
      onClose && onClose();
    }
  }

  useEffect(function () {
    function handleKeydown(event) {
      if (visible && closeOnEsc && event.key === "Escape") {
        onClose && onClose();
      }
    }

    function enablePageScrolling() {
      document.body.style.overflow = "";
    }

    function disablePageScrolling() {
      document.body.style.overflow = "hidden";
    }

    if (visible) {
      disablePageScrolling();
      document.addEventListener("keydown", handleKeydown);
    } else {
      enablePageScrolling();
      document.removeEventListener("keydown", handleKeydown);
    }

    return function cleanup() {
      enablePageScrolling();
      document.removeEventListener("keydown", handleKeydown);
    };
  }, [visible, closeOnEsc, onClose]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GlobalTransitions, null), /*#__PURE__*/React.createElement(CSSTransition, {
    timeout: 300,
    "in": visible,
    classNames: "nib-overlay",
    mountOnEnter: true,
    unmountOnExit: true,
    nodeRef: ref
  }, /*#__PURE__*/React.createElement(OverlayComponent, _extends({}, otherProps, {
    ref: ref,
    onClick: handleClick,
    mode: mode
  }), children)));
};

export default Overlay;